/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryItemDto } from '../../models/inventory-item-dto';

export interface GetInventoryItem$Params {
  id: string;
}

export function getInventoryItem(http: HttpClient, rootUrl: string, params: GetInventoryItem$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryItemDto>> {
  const rb = new RequestBuilder(rootUrl, getInventoryItem.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryItemDto>;
    })
  );
}

getInventoryItem.PATH = '/v0/inventoryItems/{id}';
